import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { Router } from '@angular/router';

@Component({
  selector: 'app-forbidden',
  standalone: true,
  imports: [CommonModule, MatButtonModule, MatIconModule],
  template: `
    <div class="forbidden-container">
      <div class="forbidden-content">
        <mat-icon class="forbidden-icon">block</mat-icon>
        <h1>Access Denied</h1>
        <p>You don't have permission to access this page.</p>
        <button mat-raised-button color="primary" (click)="goHome()">
          <mat-icon>home</mat-icon>
          Go to Home
        </button>
      </div>
    </div>
  `,
  styles: [`
    .forbidden-container {
      display: flex;
      justify-content: center;
      align-items: center;
      background-color: var(--mat-sys-on-primary);
      padding-top: 120px;
    }

    .forbidden-content {
      text-align: center;
      padding: 3rem;
      background: var(--mat-sys-surface-container-low);
      border-radius: var(--mat-sys-corner-medium);
      box-shadow: var(--mat-sys-level2);
      max-width: 600px;
      width: 100%;
    }

    .forbidden-icon {
      font-size: 80px;
      width: 80px;
      height: 80px;
      color: var(--mat-sys-error);
      margin-bottom: 1rem;
    }

    h1 {
      color: var(--mat-sys-on-surface);
      margin-bottom: 0.5rem;
      font-size: var(--mat-sys-headline-medium-size);
      font-weight: var(--mat-sys-headline-medium-weight);
      line-height: var(--mat-sys-headline-medium-line-height);
    }

    p {
      color: var(--mat-sys-on-surface-variant);
      margin-bottom: 2rem;
      line-height: 1.6;
      font-size: var(--mat-sys-body-large-size);
    }

    button {
      gap: 0.5rem;
    }
  `]
})
export class ForbiddenComponent {
  constructor(private router: Router) {}

  goHome() {
    this.router.navigate(['/']);
  }
}
